module.exports = require("core-js/modules/es.date.now.js");